import { createReducer } from "../../../utils/redux/create-reducer";
import Types from "./types";

export const INITIAL_STATE = {
    regNo: "",
    maskedPhone: "",
    challanDetails: {},
    whatsappConsent: true,
    isError: false,
    isMaxLimitReached: false,
    cartDetails: {},
    cartResponse: {},
    registrationDetails: {}
};

export const setRegNo = (state = INITIAL_STATE, { regNo = "" }) => {
    return { ...state, regNo};
};

export const setIsError = (state = INITIAL_STATE, { isError }) => {
    return { ...state, isError};
};

export const setChallanDetails = (state = INITIAL_STATE, { challanDetails = {} }) => {
    return { ...state, challanDetails};
};

export const setMaskedPhone = (state = INITIAL_STATE, {maskedPhone}) => {
    return { ...state, maskedPhone};
};

export const setWhatsappConsent = (state = INITIAL_STATE, {whatsappConsent}) => {
    return { ...state, whatsappConsent};
};

export const setIsMaxLimitReached = (state = INITIAL_STATE, { isMaxLimitReached }) => {
    return { ...state, isMaxLimitReached};
};

export const setCartDetails = (state = INITIAL_STATE, { cartDetails = {} }) => {
    return {...state, cartDetails};
};

export const setCartResponse = (state = INITIAL_STATE, { cartResponse = {} }) => {
    return {...state, cartResponse};
};

export const setRegistrationDetails = (state = INITIAL_STATE, { registrationDetails = {} }) => {
    return { ...state, registrationDetails};
};

export const HANDLERS = {
    [Types.SET_REG_NO]: setRegNo,
    [Types.SET_IS_ERROR]: setIsError,
    [Types.SET_CHALLAN_DETAILS]: setChallanDetails,
    [Types.SET_MASKED_PHONE]: setMaskedPhone,
    [Types.SET_WHATSAPP_CONSENT]: setWhatsappConsent,
    [Types.SET_IS_MAX_LIMIT_REACHED]: setIsMaxLimitReached,
    [Types.SET_CART_DETAILS]: setCartDetails,
    [Types.SET_CART_RESPONSE]: setCartResponse,
    [Types.SET_REGISTRATION_DETAILS]: setRegistrationDetails
};

export default createReducer(INITIAL_STATE, HANDLERS);
